import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

import { withTranslation } from 'language/i18n';
import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import Feature from './components/Feature';
import LeftMenu from './components/LeftMenu';

const DuruMakina = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('aboutUs'),
      url: '/about-us/about-us',
    },
    {
      label: 'Makina Hakkında',
      url: '/about-us/duru-makina',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="duruMakina" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">
                  {/* Duru */}
                  {' '}
                  Makina
                </h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <div className="float-image float-image--right">
                  <Image
                    src="/temp/kepce-image.jpg"
                    width="930"
                    height="724"
                    Layout="responsive"
                  />
                </div>
                <p>
                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.

                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.

                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.

                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.

                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.
                </p>
                <div className="clearfix" />
              </div>
            </div>
            <div className="row">
              <Feature
                indicator="43"
                title="Yıllık Tecrübe"
                description="Sektördeki tecrübemizle en iyi bildiğimiz işi yapıyoruz ve sizlere güvence veriyoruz."
              />
              <Feature
                indicator="32"
                title="Ülke Ticareti"
                description="Türkiye ve Dünya genelinde geniş satış ağımızla her zaman yanınızdayız."
              />
              <Feature
                indicator="1200+"
                title="İş Makinası Satışı"
                description="İş makinası ithalat ve ihracatıyla binlerce başarılı satış gerçekleştirdik."
              />
            </div>
            <div className="row">
              <div className="col">
                <p>
                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id
                  nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.
                </p>
                <p>
                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id
                  nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.
                </p>
                <p>
                  Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id
                  nibh
                  ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a
                  pharetra augue.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

DuruMakina.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Makina',
    },
  };
};

DuruMakina.Layout = Layout;

export default withTranslation('common')(DuruMakina);
